import { create } from 'zustand';
import { paymentsAPI } from '../api/services';

const usePaymentStore = create((set) => ({
  payments: [],
  payment: null,
  loading: false,
  error: null,
  pagination: { current: 1, pageSize: 15, total: 0 },

  fetchPayments: async (params = {}) => {
    set({ loading: true });
    try {
      const res = await paymentsAPI.getAll(params);
      const data = res.data?.data || res.data;
      set({
        payments: Array.isArray(data) ? data : data?.data || [],
        pagination: {
          current: data?.current_page || 1,
          pageSize: data?.per_page || 15,
          total: data?.total || 0,
        },
        loading: false,
      });
    } catch (err) {
      set({ error: err.message, loading: false });
    }
  },

  deletePayment: async (id) => {
    await paymentsAPI.delete(id);
  },
}));

export default usePaymentStore;
